/**
 * AuthorsPageV2 — redesigned Authors list shell, port of the
 * prototype's `.screen-authors` page-head (cms-redesign-mockup.html
 * ~7158–7166).
 *
 * Single coral "+ Add Author" header action. The body
 * (AuthorsTableV2) hosts its own search input.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AuthorsTableV2 from '../../AuthorsTable/v2/AuthorsTableV2';
import { PageHeader, Button } from '../../redesign';

const PlusSign = (
  <span style={{ fontSize: 16, lineHeight: 1 }} aria-hidden>+</span>
);

export default function AuthorsPageV2() {
  const total = useSelector((s) =>
    Array.isArray(s.authors.authors) ? s.authors.authors.length : undefined,
  );
  const totalLabel = total != null ? `${total.toLocaleString()} total` : undefined;

  return (
    <div className="bg-bg min-h-full">
      <PageHeader
        eyebrow="Content Assets"
        title="Authors"
        total={totalLabel}
        actions={
          <Link to="/authors/add" className="no-underline">
            <Button variant="coral" leadingIcon={PlusSign}>
              Add Author
            </Button>
          </Link>
        }
      />
      <AuthorsTableV2 />
    </div>
  );
}
